export enum IniExtendedErrorCode {
  MalformedSegment = 1003,
  MediaRequestCanceled = 1004,
  MediaServerConnectionUnavailable = 2001,
  UnsupportedCdmForDecryptDrm = 3001,
  DrmServerConnectionUnavailable = 3002,
  ParsingKeyFailed = 3003,
  InitializeCdmFailed = 3004,
  LicenseKeyExpired = 3006,
  LicenceKeyRequestCanceled = 3007,
  UnsupportedMimetype = 4001,
  MalfomedManifest = 4002,
  UnsupportedCodec = 4003,
  ManifestServerConnectionUnavailable = 4004,
  ManifestRequestCanceled = 4005,
  WrongStart = 9001,
  UnsupportedSystem = 9002,
  IniInternal = 9999,
  // 혹시나 에러가 발생했는데 에러코드가 없는 경우 사용
  Unknown = 10000,
  // HDCP에러인 경우
  UnsupportedHdcp = 10001,
  // 아예 동영상을 지원할 수 없어 IniPlayer도 생성되지 않는 경우
  // 브라우저가 DRM 엔진 자체를 지원하지 않거나, 브라우저 옵션에서 보호된 콘텐츠 보기 옵션이 차단된 경우 등에 발생한다.
  UnsupportedBrowser = 10002,
  // 필요한 데이터를 API에서 가져오는 데 실패해서 재생할 수 없는 경우
  GetVideoDataFailed = 10003,
  // iOS 15.0.x 웹브라우저 오류로 인해 Fairplay DRM 영상을 재생할 수 없는 경우
  OsFairplayBugVersion = 10004,
}
